import ChannelDMsPage from './ChannelDMsPage';

export default function ChannelDMsTab({ channel, isMobile }) {
    return (
        <div style={{ height: '100%', borderRadius: isMobile ? 0 : '14px', overflow: 'hidden', border: isMobile ? 'none' : '1px solid var(--border)' }}>
            <ChannelDMsPage embedded={true} channel={channel} isMobile={isMobile} />
        </div>
    );
}
